export interface VideoItem {
  id: string;
  title: string;
  description: string;
  category: string;
  thumbnail: string;
  duration: string;
  quality: string;
  views: number;
  rating: number;
  year: number;
  tags: string[];
  source: string;
  featured?: boolean;
  trending?: boolean;
  date: string;
}

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '流浪地球3',
    description: '太阳急速老化，地球面临被吞没的危机。人类再次启动流浪地球计划，带着地球去往新的家园。一场关乎人类命运的史诗冒险再次开启。',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20style%2C%20massive%20spaceship%20in%20deep%20space%20with%20glowing%20orange%20nebula%20background%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20dark%20atmosphere%20with%20warm%20highlights%2C%20film%20poster%20quality&width=800&height=450&seq=video-thumb-001&orientation=landscape',
    duration: '02:28:15',
    quality: '4K',
    views: 1280000,
    rating: 9.2,
    year: 2026,
    tags: ['科幻', '冒险', '国产'],
    source: '西瓜视频',
    featured: true,
    trending: true,
    date: '2026-07-28',
  },
  {
    id: 'v002',
    title: '繁花似锦',
    description: '讲述上世纪九十年代上海滩的风云变幻，一群年轻人在时代浪潮中追逐梦想、收获爱情的动人故事。阿宝凭借敏锐的商业嗅觉，在改革开放的大潮中闯出一片天地。',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20cityscape%20at%20night%20with%20neon%20lights%2C%20retro%20Chinese%20drama%20aesthetic%2C%20warm%20golden%20tones%2C%20elegant%20nostalgic%20atmosphere%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting&width=800&height=450&seq=video-thumb-002&orientation=landscape',
    duration: '00:45:00',
    quality: '1080P',
    views: 890000,
    rating: 8.8,
    year: 2026,
    tags: ['都市', '情感', '年代'],
    source: '91视频网站',
    featured: true,
    trending: true,
    date: '2026-07-25',
  },
  {
    id: 'v003',
    title: '极限挑战第十季',
    description: '黄渤、孙红雷、黄磊等原班人马回归，全新挑战任务带来无限欢乐。这一季他们将走遍全国各地，体验不同的职业人生，用智慧和勇气完成一个个看似不可能的任务。',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Outdoor%20variety%20show%20aesthetic%2C%20group%20of%20people%20running%20and%20laughing%20in%20colorful%20city%20street%2C%20bright%20vibrant%20game%20show%20style%2C%20energetic%20atmosphere%2C%20warm%20lighting%2C%20fun%20and%20playful%20composition&width=800&height=450&seq=video-thumb-003&orientation=landscape',
    duration: '01:30:00',
    quality: '1080P',
    views: 650000,
    rating: 8.5,
    year: 2026,
    tags: ['真人秀', '搞笑', '挑战'],
    source: '西瓜视频',
    featured: true,
    trending: false,
    date: '2026-07-20',
  },
  {
    id: 'v004',
    title: '深海传奇',
    description: '在神秘的海底世界，少女参宿意外进入了深海大饭店，遇到了形形色色的海底生物。一段关于勇气、友情和自我发现的奇幻冒险由此展开。',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Magical%20underwater%20world%20anime%20style%2C%20colorful%20coral%20reef%20with%20fantastical%20sea%20creatures%2C%20dreamy%20atmosphere%2C%20bioluminescent%20glow%2C%20Chinese%20animation%20aesthetic%2C%20rich%20deep%20blue%20and%20teal%20color%20palette&width=800&height=450&seq=video-thumb-004&orientation=landscape',
    duration: '01:52:00',
    quality: '4K',
    views: 920000,
    rating: 9.0,
    year: 2026,
    tags: ['奇幻', '冒险', '国产动漫'],
    source: '91视频网站',
    featured: false,
    trending: true,
    date: '2026-07-18',
  },
  {
    id: 'v005',
    title: '地球脉动·亚洲篇',
    description: 'BBC团队历时四年拍摄，深入亚洲大陆最偏远的角落，记录从西伯利亚冰原到东南亚热带雨林的壮丽自然景观和珍稀野生动物。',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20nature%20documentary%20style%2C%20snow%20leopard%20in%20Himalayan%20mountains%2C%20dramatic%20landscape%20with%20golden%20sunset%20light%2C%20cinematic%20wildlife%20photography%2C%20majestic%20mountain%20peaks%2C%20natural%20warm%20tones&width=800&height=450&seq=video-thumb-005&orientation=landscape',
    duration: '00:58:00',
    quality: '4K',
    views: 450000,
    rating: 9.6,
    year: 2026,
    tags: ['自然', '动物', 'BBC'],
    source: '西瓜视频',
    featured: false,
    trending: false,
    date: '2026-07-15',
  },
  {
    id: 'v006',
    title: '超级飞侠大电影',
    description: '乐迪和他的超级飞侠伙伴们再次出发，这次他们要前往一个神秘的岛屿，帮助那里的孩子们解决一个大麻烦。充满欢乐和正能量的亲子动画。',
    category: 'shaoer',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cute%20colorful%203D%20animated%20airplane%20characters%20flying%20over%20tropical%20island%2C%20kids%20animation%20style%2C%20bright%20and%20cheerful%2C%20clear%20blue%20sky%20with%20fluffy%20clouds%2C%20playful%20and%20fun%20atmosphere%2C%20warm%20sunlight&width=800&height=450&seq=video-thumb-006&orientation=landscape',
    duration: '01:25:00',
    quality: '1080P',
    views: 320000,
    rating: 8.2,
    year: 2026,
    tags: ['动画', '亲子', '冒险'],
    source: '91视频网站',
    featured: false,
    trending: false,
    date: '2026-07-10',
  },
  {
    id: 'v007',
    title: '无名之辈2',
    description: '一座西部小城，几个素不相识的普通人因为一桩意外事件被命运纠缠在一起。黑色幽默包裹下的人性悲欢，笑中带泪的荒诞故事。',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20small%20western%20town%20at%20dusk%2C%20dusty%20street%20with%20old%20buildings%2C%20dark%20comedy%20film%20aesthetic%2C%20warm%20desert%20tones%2C%20cinematic%20lighting%20with%20long%20shadows%2C%20mysterious%20atmosphere&width=800&height=450&seq=video-thumb-007&orientation=landscape',
    duration: '01:55:30',
    quality: '1080P',
    views: 760000,
    rating: 8.7,
    year: 2026,
    tags: ['喜剧', '剧情', '国产'],
    source: '西瓜视频',
    featured: true,
    trending: false,
    date: '2026-07-05',
  },
  {
    id: 'v008',
    title: '大宋风华录',
    description: '以北宋仁宗朝为背景，讲述一代名臣范仲淹从寒门学子到位极人臣的传奇人生，展现大宋王朝的繁华与危机，以及士大夫的家国情怀。',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Song%20dynasty%20imperial%20palace%20interior%2C%20elegant%20historical%20costume%20drama%20style%2C%20warm%20candlelight%20illumination%2C%20rich%20silk%20textures%2C%20traditional%20Chinese%20aesthetic%2C%20refined%20and%20majestic%20atmosphere&width=800&height=450&seq=video-thumb-008&orientation=landscape',
    duration: '00:45:00',
    quality: '4K',
    views: 1100000,
    rating: 9.1,
    year: 2026,
    tags: ['古装', '历史', '剧情'],
    source: '91视频网站',
    featured: false,
    trending: true,
    date: '2026-07-01',
  },
  {
    id: 'v009',
    title: '歌手2026',
    description: '华语乐坛顶级歌手齐聚一堂，用音乐诠释灵魂。全新赛制，残酷淘汰，谁能问鼎歌王宝座？每周五晚精彩对决不容错过。',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Grand%20music%20stage%20with%20dramatic%20spotlight%20and%20concert%20lighting%2C%20singing%20competition%20show%20aesthetic%2C%20dark%20background%20with%20vibrant%20golden%20stage%20lights%2C%20professional%20concert%20photography%20style%2C%20energetic%20performance%20atmosphere&width=800&height=450&seq=video-thumb-009&orientation=landscape',
    duration: '02:00:00',
    quality: '4K',
    views: 1500000,
    rating: 8.9,
    year: 2026,
    tags: ['音乐', '竞技', '直播'],
    source: '西瓜视频',
    featured: true,
    trending: true,
    date: '2026-06-28',
  },
  {
    id: 'v010',
    title: '狐妖小红娘·竹业篇',
    description: '东方月初与涂山红红的千年之约进入新的篇章。竹林中相遇，命运交织，一段跨越人妖两界的动人爱情故事缓缓拉开帷幕。',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20anime%20style%2C%20beautiful%20fox%20spirit%20in%20bamboo%20forest%2C%20ethereal%20atmosphere%20with%20floating%20cherry%20blossoms%2C%20soft%20pink%20and%20green%20color%20palette%2C%20romantic%20and%20mystical%2C%20traditional%20Chinese%20art%20influenced&width=800&height=450&seq=video-thumb-010&orientation=landscape',
    duration: '00:24:00',
    quality: '1080P',
    views: 580000,
    rating: 9.3,
    year: 2026,
    tags: ['爱情', '奇幻', '国漫'],
    source: '91视频网站',
    featured: false,
    trending: true,
    date: '2026-06-20',
  },
  {
    id: 'v011',
    title: '河西走廊·新篇',
    description: '沿着古老的丝绸之路，探索河西走廊千年的文明变迁。从敦煌莫高窟到酒泉卫星发射中心，见证这片土地上的历史与现代交织。',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20ancient%20Silk%20Road%20landscape%2C%20Gobi%20desert%20with%20dramatic%20sand%20dunes%20and%20distant%20snow%20mountains%2C%20golden%20sunset%20lighting%2C%20cinematic%20documentary%20style%2C%20vast%20and%20majestic%2C%20warm%20earthy%20tones&width=800&height=450&seq=video-thumb-011&orientation=landscape',
    duration: '00:50:00',
    quality: '4K',
    views: 380000,
    rating: 9.5,
    year: 2026,
    tags: ['历史', '地理', '文化'],
    source: '西瓜视频',
    featured: false,
    trending: false,
    date: '2026-06-15',
  },
  {
    id: 'v012',
    title: '小猪佩奇过大年',
    description: '佩奇和乔治来到中国过春节，体验贴春联、包饺子、放烟花等传统习俗。中英文化的碰撞带来无限欢乐，全家老少一起乐翻天。',
    category: 'shaoer',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20pig%20family%20celebrating%20Chinese%20New%20Year%2C%20red%20lanterns%20and%20fireworks%2C%20festive%20atmosphere%2C%20kids%20animation%20style%2C%20warm%20and%20joyful%2C%20traditional%20Chinese%20decorations&width=800&height=450&seq=video-thumb-012&orientation=landscape',
    duration: '01:18:00',
    quality: '1080P',
    views: 280000,
    rating: 7.9,
    year: 2026,
    tags: ['动画', '亲子', '春节'],
    source: '91视频网站',
    featured: false,
    trending: false,
    date: '2026-06-10',
  },
];

export const featuredVideos = videos.filter(v => v.featured);
export const trendingVideos = videos.filter(v => v.trending);
export const latestVideos = [...videos].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());